import React from "react";
import { Box, Container, Stack, Typography } from "@mui/material";

const Footer = () => (
  <Box component="footer" sx={{
    pt: 8, pb: { xs: 12, md: 8 }, 
    borderTop: "1px solid rgba(107, 117, 130, 0.2)",
  }}>
    <Container maxWidth="lg">
      <Stack direction={{ xs: "column", md: "row" }} justifyContent="space-between" alignItems="center" spacing={2}>
        <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.7rem", color: "#858d99", letterSpacing: "0.15em" }}>
          SYS_TERMINATED // DOSSIER_CLOSED
        </Typography>
        <Typography sx={{ fontFamily: "'JetBrains Mono', monospace", fontSize: "0.7rem", color: "#00f0ff", letterSpacing: "0.15em", animation: "blink 2s steps(1) infinite" }}>
          [EOF]
        </Typography>
      </Stack>
    </Container>
  </Box>
);

export default Footer;
